export const loadJsCheckoutLibrary = () => {
  var MID = 'sOGYCE31009545550862';
  var URL = 'https://securegw.paytm.in/merchantpgpui/checkoutjs/sOGYCE31009545550862';
  var merchantCallback = null;
  var createDOMElements = function(input) {
    var scriptEle = document.createElement('script'),
      cssEle = document.createElement('link');

    if (cssEle) {
      cssEle.href = input.style;
      cssEle.rel = 'stylesheet';
      cssEle.type = 'text/css';
      document.head.appendChild(cssEle);
    }
    if (scriptEle) {
      scriptEle.async = true;
      scriptEle.src = input.js;
      scriptEle.type = 'application/javascript';
      scriptEle.crossOrigin = 'anonymous';
      scriptEle.onload = function () {
        if (window.CheckoutJS) {
          if (window.Paytm && window.Paytm.CheckoutJS) {
            for (var key in window.CheckoutJS) {
              // eslint-disable-next-line no-prototype-builtins
              if (window.CheckoutJS.hasOwnProperty(key)) {
                window.Paytm.CheckoutJS[key] = window.CheckoutJS[key];
              }
            }
          }
          try {
            delete window.CheckoutJS; // remove CheckoutJS from window scope
          } catch (e) { console.log(e);}
          if (window.Paytm.CheckoutJS.initLib) {
            window.Paytm.CheckoutJS.initLib(MID).then(function () {
              if (merchantCallback) {
                merchantCallback.call();
              }
            });
          }
        }
      };
      document.body.appendChild(scriptEle);
    }
  };

  var post = function() {
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function() {
      if (this.readyState === 4) {
        var data = JSON.parse(this.responseText);
        createDOMElements(data);
      }
    };
    xhr.open('GET', URL, true);
    xhr.setRequestHeader('Content-Type', 'application/javascript; charset=utf-8');
    xhr.send(null);
  };

  post();

  if(!window.Paytm){
    // check if window.Paytm exists or not
    window.Paytm = {};
  }

  window.Paytm.CheckoutJS = {
    onLoad: function(callback) {
      if (!callback || callback.constructor !== Function) {
        throw new Error('callback in onLoad function should be of function type');
      }
      merchantCallback = callback;
    }
  };
};


  export const   initPaytmJsCheckout=(orderId,token,txnAmountValue)=>{

    try {
      var config = {
        'root': '',
        'flow': 'DEFAULT',
        'data': {
        'orderId': `${orderId}`, /* update order id */
        'token': `${token}`, /* update token value */
        'tokenType': 'TXN_TOKEN',
        'amount': `${txnAmountValue}` /* update amount */
        },
        'handler': {
          'notifyMerchant': function(eventName,data){
            console.log('notifyMerchant handler function called');
            console.log('eventName => ',eventName);
            console.log('data => ',data);
          } 
        }
      };
  
      if(window.Paytm && window.Paytm.CheckoutJS){
          window.Paytm.CheckoutJS.onLoad(function excecuteAfterCompleteLoad() {
              // initialize configuration using init method 
              window.Paytm.CheckoutJS.init(config).then(function onSuccess() {
                  // after successfully updating configuration, invoke JS Checkout
                  window.Paytm.CheckoutJS.invoke();
              }).catch(function onError(error){
                  console.log('error => ',error);
              });
          });
      }   
    } catch (error) {
      console.log(error);
    }
    
    console.log('initPaytmJsCheckout triggered');

  
};